import { render, staticRenderFns } from "./BarcodeOrderItemUpdate.vue?vue&type=template&id=321b2011"
import script from "./BarcodeOrderItemUpdate.vue?vue&type=script&lang=ts"
export * from "./BarcodeOrderItemUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports